import {makeAutoObservable, action, runInAction} from "mobx";
import { MIXED_PRECISION_OPTIONS } from "../component/AdvanceSetting/AdvanceSetting";
import { SAMPLER_OPTIONS } from "../component/AdvanceSetting/AdvanceSetting";
import { SAVE_PRECISION_OPTIONS } from "../component/AdvanceSetting/AdvanceSetting";
import { LEARNING_RATE_OPTIONS } from "../component/AdvanceSetting/AdvanceSetting";
import { LR_SCHEDULER_OPTIONS } from "../component/AdvanceSetting/AdvanceSetting";
import { OPTIMIZER_OPTIONS } from "../component/AdvanceSetting/AdvanceSetting";
import { MAX_TOKEN_LENGTH_OPTIONS } from "../component/AdvanceSetting/AdvanceSetting";
import { LEARNING_RATE_OPTIONS_1 } from "../component/AdvanceSetting/AdvanceSetting";

export class AdvanceSettingStore{
    constructor(){
        makeAutoObservable(this);
    }

    // 单张训练次数
    private _repeat: number = 1;
    get repeat(): number{
        return this._repeat;
    }
    set repeat(a: number){
        this._repeat = a ;
    }

    //训练轮数
    private _epoch: number = 20;
    get epoch(): number{
        return this._epoch;
    }
    set epoch(a: number){
        this._epoch = a;
    }

    // 批量大小
    private _batchSize: number = 1;
    get batchSize(): number{
        return this._batchSize;
    }
    set batchSize(a: number){
        this._batchSize = a;
    }

    // 训练混合精度
    private _mixedPrecision: string = MIXED_PRECISION_OPTIONS[1].value;
    get mixedPrecision(): string{
        return this._mixedPrecision;
    }
    set mixedPrecision(a: string){
        this._mixedPrecision = a;
    }

    // 样图分辨率
    private _resolution: number[] = [1024, 1024];
    get resolution(): number[]{
        return this._resolution;
    }
    set resolution(a: number[]){
        this._resolution = a;
    }

    // 随机种子数
    private _seed: number = -1;
    get seed(): number{
        return this._seed;
    }
    set seed(a: number){
        this._seed = a;
    }

    // 采样方式
    private _sampler: string = SAMPLER_OPTIONS[0].value;
    get sampler(): string{
        return this._sampler;
    }
    set sampler(a: string){
        this._sampler = a;
    }

    // 提示词
    private _prompt: string = "";
    get prompt(): string{
        return this._prompt;
    }
    set prompt(a: string){
        this._prompt = a;
    }

    // 每轮保存lora
    private _saveEveryNEpochs: number = 5;
    get saveEveryNEpochs(): number{
        return this._saveEveryNEpochs;
    }
    set saveEveryNEpochs(a: number){
        this._saveEveryNEpochs = a;
    }

    // lora保存精度
    private _savePrecision: string = SAVE_PRECISION_OPTIONS[0].value;
    get savePrecision(): string{
        return this._savePrecision;
    }
    set savePrecision(a: string){
        this._savePrecision =a;
    }

    // 总学习率
    private _learningRate: string = LEARNING_RATE_OPTIONS[3].value;
    get learningRate(): string{
        return this._learningRate;
    }
    set learningRate(a: string){
        this._learningRate =a;
    }

    // unet学习率
    private _unetlr: number = 0.0001;
    get unetlr(): number{
        return this._unetlr;
    }
    set unetlr(a: number){
        this._unetlr = a;
    }

    // 文本编码学习率
    private _textEncoderLr: number = 0.0001;
    get textEncoderLr(): number{
        return this._textEncoderLr;
    }
    set textEncoderLr(a: number){
        this._textEncoderLr = a;
    }

    // 学习率预热
    private _lrWarmUp: number = 0;
    get lrWarmUp(): number{
        return this._lrWarmUp;
    }
    set lrWarmUp(a: number){
        this._lrWarmUp = a ;
    }

    // 学习率调度器
    private _lrScheduler: string = LR_SCHEDULER_OPTIONS[0].value;
    get lrScheduler(): string{
        return this._lrScheduler;
    }
    set lrScheduler(a: string){
        this._lrScheduler = a;
    }

    // 优化器
    private _optimizer: string = OPTIMIZER_OPTIONS[0].value;
    get optimizer(): string{
        return this._optimizer;
    }
    set optimizer(a: string){
        this._optimizer = a;

        if(a === OPTIMIZER_OPTIONS[OPTIMIZER_OPTIONS.length - 1].value){
            this._learningRate = LEARNING_RATE_OPTIONS_1[0].value;
        }
    }

    // 重启次数
    private _lrSchedulerNumCycles: number = 1;
    get lrSchedulerNumCycles(): number{
        return this._lrSchedulerNumCycles
    }

    set lrSchedulerNumCycles(a: number){
        this._lrSchedulerNumCycles = a;
    }

    // 仅训练unet
    private _trainUnetOnly: boolean = true;
    get trainUnetOnly(): boolean{
        return this._trainUnetOnly;
    }
    set trainUnetOnly(a: boolean){
        this._trainUnetOnly = a;
    }

    // 仅训练文本编码器
    private _trainTextEncoderOnly: boolean = false;
    get trainTextEncoderOnly(): boolean{
        return this._trainTextEncoderOnly;
    }
    set trainTextEncoderOnly(a: boolean){
        this._trainTextEncoderOnly = a;
    }

    // 最小信噪比伽马值
    private _minSnrGamma: number = 0;
    get minSnrGamma(): number{
        return this._minSnrGamma;
    }
    set minSnrGamma(a: number){
        this._minSnrGamma = a;
    }

    // 网络大小
    private _networkRankDim: number = 16;
    get networkRankDim(): number{
        return this._networkRankDim;
    }
    set networkRankDim(a: number){
        this._networkRankDim = a;
    }

    // 网络Alpha
    private _networkAlpha: number = 16;
    get networkAlpha(): number{
        return this._networkAlpha;
    }
    set networkAlpha(a: number){
        this._networkAlpha = a;
    }

    // 保持n个token
    private _keepNTokens: number = 1;
    get keepNTokens(): number{
        return this._keepNTokens;
    }
    set keepNTokens(a: number){
        this._keepNTokens = a;
    }

    // 最大token长度
    private _maxTokenLength: string = MAX_TOKEN_LENGTH_OPTIONS[0].value;
    get maxTokenLength(): string{
        return this._maxTokenLength;
    }
    set maxTokenLength(a: string){
        this._maxTokenLength = a;
    }

    // 噪声偏移
    private _noiseOffset: number = 0.1;
    get noiseOffset(): number{
        return this._noiseOffset;
    }
    set noiseOffset(a: number){
        this._noiseOffset = a;
    }

    // 多分辨率（金字塔）噪声扩散次数
    private _multiresNoiseIterations: number = 0;
    get multiresNoiseIterations(): number{
        return this._multiresNoiseIterations;
    }
    set multiresNoiseIterations(a: number){
        this._multiresNoiseIterations = a;
    }

    // 多分辨率（金字塔）衰减率
    private _multiresNoiseDiscount: number = 0;
    get multiresNoiseDiscount(): number{
        return this._multiresNoiseDiscount;
    }
    set multiresNoiseDiscount(a: number){
        this._multiresNoiseDiscount = a;
    }

    // 高级设置 随机种子数
    private _advanceSeed: number = -1;
    get advanceSeed(): number{
        return this._advanceSeed;
    }
    set advanceSeed(a: number){
        this._advanceSeed =a ;
    }

    // clip跳过
    private _clipSkip: number = 2;
    get clipSkip(): number{
        return this._clipSkip;
    }
    set clipSkip(a: number){
        this._clipSkip = a;
    }

    // 模型名称
    private _modelName: string = "";
    get modelName(): string{
        return this._modelName;
    }
    set modelName(a: string){
        this._modelName = a;
    }
}